import React, {useEffect, useState} from "react";
import "./ChildSafetyStandards.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import {getAssetPath} from "../../services/helpers";
import {useNavigate} from "react-router-dom";

import {getLocalStorageData, storeData} from "../../services/localStorageService";

const ChildSafetyStandards = () => {

    return (
        <>
            <main className="main_wrapper terms-page">
       <div className="inn-ban" style={{marginBottom:50}}>
            <div className="container">
                <div className="row">
                    <h1>Child Safety Standards & CSAE Policy</h1>
                </div>
            </div>
        </div>
        
        <div className="container">
        {/* Introduction */}
        <div className="terms-div" id="introduction">
          <h2 className="div-title">1. Introduction</h2>

          <p>VMM - Vikas Mandal Mulund is a matrimonial profile platform operated by VIKAS MANDAL MULUND. The platform allows users to create and manage matrimonial profiles.</p>
          <p>VMM - Vikas Mandal Mulund does not provide direct user-to-user communication, chat, messaging, or social networking functionality within the application.</p>
          <p>We are committed to maintaining a safe platform and have zero tolerance for Child Sexual Abuse and Exploitation (CSAE) or Child Sexual Abuse Material (CSAM).</p>
        </div>

        <div className="terms-div" id="eligibility">
          <h2 className="div-title">
            2. Prohibition of Child Sexual Abuse and Exploitation
          </h2>
          <p>The use of VMM - Vikas Mandal Mulund for any form of child sexual abuse or exploitation is strictly prohibited.</p>
          <h3>Users must not:</h3>
       <ul className="terms-list">
            <li>Create or submit a profile representing a child for matrimonial purposes.</li>
            <li>Use the platform to facilitate the sexual exploitation or abuse of a child.</li>
            <li>Upload, submit, or distribute Child Sexual Abuse Material (CSAM).</li>
            <li>Upload or submit sexually explicit content involving a minor.</li>
            <li>Use the platform for grooming or sexually exploiting children.</li>
            <li>Facilitate child trafficking or the commercial sexual exploitation of children.</li>
            <li>Attempt to circumvent age-related restrictions or safety measures.</li>
            <li>Use the platform for any other activity that sexually exploits, abuses, or endangers a child.</li>
          </ul>

        </div>

        <div className="terms-div" id="mobile-app-terms">
          <h2 className="div-title">
         3. Age Requirements
          </h2>

          <p>
            VMM - Vikas Mandal Mulund is intended for adults seeking matrimonial relationships.
          </p>
          <p>Users are required to provide accurate information when creating a profile and must not misrepresent their age.</p>
          <p>Profiles representing minors are not permitted on the platform.</p>
          <p>We may take appropriate action where we identify or receive a report indicating that a profile does not comply with the applicable age requirements.</p>
        </div>

        <div className="terms-div" id="third-party">
          <h2 className="div-title">
          4. Child Sexual Abuse Material (CSAM)
          </h2>

          <p>
          VMM - Vikas Mandal Mulund strictly prohibits the submission, upload, storage, or distribution of CSAM through the platform.
          </p>

          <p>
           If we become aware of content or activity that may involve CSAM or child sexual exploitation, we will take appropriate action, which may include removing or restricting the relevant content, suspending or terminating the associated account, preserving relevant information where legally appropriate, and reporting the matter to the appropriate authorities or reporting organizations where required by applicable law.
          </p>

        
        </div>

        <div className="terms-div" id="terms-use">
          <h2 className="div-title">
            5. Reporting Child Safety Concerns
          </h2>

          <p>
            Users can report suspected child sexual abuse, exploitation, CSAM, or other child-safety concerns to us using the child-safety contact information provided below.
          </p>

          <p>
            Reports should include sufficient information to allow us to identify the relevant profile or content and investigate the concern.
          </p>

         <p><strong>Child Safety Contact: Dr. K G Bhole / President</strong></p>
         <p>Email: <a href="mailto:vikasmandalmulund@gmail.com">
  vikasmandalmulund@gmail.com
</a></p>
<p>We encourage users to report child-safety concerns promptly.</p>
        </div>
        

        <div className="terms-div" id="termination">
          <h2 className="div-title">
         6. Action on Violations
          </h2>

          <p>
            We take child-safety concerns seriously.
          </p>
          <p>Where we identify activity that violates this policy, we may take appropriate action, including:</p>
            <ul className="terms-list">
              <li>Removing prohibited content.</li>
               <li>Restricting or disabling a profile. </li>
                <li>Suspending an account.</li>
                 <li>Permanently terminating an account.</li>
                  <li>Preventing further use of the platform.</li>
                   <li>Reporting suspected unlawful activity to the appropriate authorities where required by applicable law.</li>
            </ul>
            <p>The action taken will depend on the nature and circumstances of the violation.</p>
        </div>

        <div className="terms-div" id="ownership-rights">
          <h2 className="div-title">
            7. Cooperation With Authorities
          </h2>

          <p>
VIKAS MANDAL MULUND complies with applicable laws and regulations concerning child safety.
          </p>

          <p>Where required by law, we may cooperate with law-enforcement authorities, child-protection organizations, or other appropriate authorities in connection with suspected child sexual abuse or exploitation.</p>
        </div>


        <div className="terms-div" id="content-rights">
          <h2 className="div-title">
            8. Platform Safety
          </h2>

          <p>
           Because VMM - Vikas Mandal Mulund does not provide user-to-user messaging, chat, or direct communication functionality, users cannot use the application to communicate directly with other users through these features.
          </p>
      <p>Nevertheless, we maintain these standards to clearly prohibit the use of the platform for CSAE and CSAM and to provide a mechanism for reporting child-safety concerns.</p>
        </div>


        <div className="terms-div" id="copyright-policy">
          <h2 className="div-title">
          9. Privacy
          </h2>

          <p>
           Information provided as part of a child-safety report will be handled in accordance with our Privacy Policy and applicable laws.
           </p>

          <p>
Information may be used to investigate the report, protect users, enforce our policies, and comply with legal obligations.
          </p>

        </div>


          <div className="terms-div" id="member-disputes">
            <h2 className="div-title">
             10. Updates to These Standards
            </h2>

            <p>
             We may update these Child Safety Standards from time to time to reflect changes in our platform, applicable laws, safety practices, or regulatory requirements.
            </p>
      <p>The latest version will always be published on this page.</p>
           
          </div>


  <div className="terms-div" id="member-disputes">
            <h2 className="div-title">
            11. Contact Information
            </h2>

            <p>
For questions or concerns relating specifically to child safety, CSAE, or CSAM, please contact:
            </p>
      <p><strong>VIKAS MANDAL MULUND</strong></p>
      <p><strong>Child Safety Contact: Dr. K G Bhole / President</strong></p>
      <p><strong>Email: <a href="mailto:vikasmandalmulund@gmail.com">
  vikasmandalmulund@gmail.com
</a></strong></p>
           <p><strong>Website: <a target="_blank" href="https://vikasmandalmulund.com">
  https://vikasmandalmulund.com
</a></strong></p>
<p><strong>VMM - Vikas Mandal Mulund</strong> is committed to maintaining a safe matrimonial platform and does not tolerate child sexual abuse, child sexual exploitation, or Child Sexual Abuse Material.</p>
          </div>

          </div>
      </main>
        </>
    );
};

export default ChildSafetyStandards;
